import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'

import {Paper,Grid} from '@material-ui/core'

import Menu from './menu'
import ExpensesGrid from './expenses-grid'

import callAccountsApi from '../data-provider'

const styles = theme => ({
  paper: {
    width: 'calc(100% - 20)',
    overflowX: 'auto',
    backgroundColor : '#fff',
    padding : 10,
    textAlign : 'center'
  },
  yearNumber : {
    fontSize : '32px',
    marginTop : '40px !important',
    marginBottom : '10px !important',
  }
})

class Reports extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {years:[]}
  }
  
  componentDidMount() {
    this.getExpenses()
  }

  getExpenses = async () => {
    let years = await callAccountsApi("reports","getExpenses")
    this.setState({years})
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
        <Menu page="expenses"/>

        <Paper className={classes.paper}>
          <Grid container justify="space-around" direction="column">
            
            {Object.keys(this.state.years).map(y =>
              <React.Fragment>
                <Grid item><div className={classes.yearNumber}>{y}</div></Grid>
                
                <Grid item>
                  <ExpensesGrid dividends={this.state.years[y]} year={parseInt(y,10)}/>
                </Grid>
              </React.Fragment>
            )}

            </Grid>
        </Paper>

      </React.Fragment>
    )
  }
}

export default withRouter(withStyles(styles)(Reports))